function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M11.5 21a9.5 9.5 0 100-19 9.5 9.5 0 000 19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.3 22c-.18 0-.36-.07-.49-.2l-1.86-1.86a.706.706 0 010-.99c.27-.27.71-.27.99 0l1.86 1.86c.27.27.27.71 0 .99-.14.13-.32.2-.5.2zM13.27 8.89c-.63-.2-1.3-.08-1.78.29-.49-.37-1.14-.49-1.77-.29-1.36.44-1.79 1.99-1.41 3.17.58 1.81 2.49 2.75 3.18 2.75.67 0 2.62-.96 3.18-2.75.39-1.18-.04-2.73-1.4-3.17z"
})));